import { __assign, __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { Button, ButtonGroup, Stack, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { AuthPasswordField, FieldControl, } from "@pangeacyber/react-mui-shared";
import { useCreateShareContext, useStoreFileViewerContext, } from "../../hooks/context";
import { passwordGenerator, checkPassword } from "../../utils";
var UnControlledGeneratePasswordField = function (_a) {
    var _b, _c, _d;
    var onValueChange = _a.onValueChange, props = __rest(_a, ["onValueChange"]);
    var configurations = useStoreFileViewerContext().configurations;
    var _e = useCreateShareContext(), errors = _e.errors, password = _e.password, setPassword = _e.setPassword;
    var theme = useTheme();
    var onError = (_b = props === null || props === void 0 ? void 0 : props.FieldProps) === null || _b === void 0 ? void 0 : _b.errorCallback;
    var disabled = ((_c = props === null || props === void 0 ? void 0 : props.FieldProps) === null || _c === void 0 ? void 0 : _c.disabled) || false;
    var _f = useState(), error = _f[0], setError = _f[1];
    var handleValueChange = function (value) {
        var isValid = checkPassword(value, configurations === null || configurations === void 0 ? void 0 : configurations.passwordPolicy);
        setError(!isValid);
        if (onError) {
            onError(!isValid);
        }
        if (onValueChange) {
            onValueChange(value);
        }
        setPassword(value);
    };
    return (_jsxs(Stack, { gap: 0.5, children: [_jsxs(ButtonGroup, { sx: {
                    flexGrow: 1,
                    width: "100%",
                    ".MuiFormGroup-root": {
                        width: "calc(100% - 140px)",
                    },
                    ".MuiPopper-root": {
                        zIndex: theme.zIndex.modal + 1,
                    },
                }, children: [_jsx(AuthPasswordField, __assign({}, props, { value: password || "", onValueChange: handleValueChange, disabled: disabled, FieldProps: __assign(__assign({}, props === null || props === void 0 ? void 0 : props.FieldProps), { type: "passwordWithPolicy", policy: (_d = configurations === null || configurations === void 0 ? void 0 : configurations.passwordPolicy) !== null && _d !== void 0 ? _d : {
                                chars_min: 8,
                            }, InputProps: {
                                fullWidth: true,
                                sx: {
                                    borderBottomRightRadius: "0!important",
                                    borderTopRightRadius: "0!important",
                                },
                            } }) })), _jsx(Button, { variant: "contained", color: "secondary", onClick: function () {
                            handleValueChange(passwordGenerator(10));
                        }, disabled: disabled, sx: {
                            color: theme.palette.primary.main,
                            borderBottomLeftRadius: "0!important",
                            borderTopLeftRadius: "0!important",
                            boxShadow: "none",
                            zIndex: 0,
                            flex: 1,
                        }, children: "Suggest" })] }), (error || !!(errors === null || errors === void 0 ? void 0 : errors.password)) && (_jsx(Typography, { variant: "caption", color: "error", ml: 1, children: !!(errors === null || errors === void 0 ? void 0 : errors.password) || "Password does not meet requirements" }))] }));
};
var GeneratePasswordField = function (props) {
    return (_jsx(FieldControl, __assign({}, props, { children: _jsx(UnControlledGeneratePasswordField, __assign({}, props)) })));
};
export default GeneratePasswordField;
